import { render, staticRenderFns } from "./GlobalDiscountPricingForm.vue?vue&type=template&id=5a20baa8&"
import script from "./GlobalDiscountPricingForm.vue?vue&type=script&lang=js&"
export * from "./GlobalDiscountPricingForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports